import React from 'react';

const BmbTheme = {
  headerLogo: {
    src: '/themes/theme/bmb/logo.png',
    alt: 'British Master Barbers',
  },
  darkLogo: {
    src: '/themes/theme/bmb/logo-black.png',
    alt: 'British Master Barbers',
  },
  headerStyle: {
    backgroundColor: '#000',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#FFF',
    fontWeight: 800,
    fontSize: '120%',
  },
  isLightOnDark: true,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="250" src="/themes/theme/bmb/logo.jpg" alt="British Master Barbers" />
    </div>
  ),
  shareSite: 'https://bmbr.dyzio.co',
  organisationId: 'c1616c2e-8904-4456-b2b4-1b7ecaecbf29',
  captureInfluencerAddressDetails: true,
  copy: {
    joinTitle:
     'Join our influencer network today',

    joinDescription: (
      <div>
        <p>We offer you the opportunity to collaborate with global brands, on new and exciting briefs.</p>
        <p>We just ask that you update your member details so we can verify who you are!</p>
      </div>
    ),

    featureList: (
      <div>
        <h4>Please verify your details so we can add you to the network</h4>
        <ul>
          <li>Check your Business name</li>
          <li>Add address details so we can add you to our App directory</li>
          <li>Add social handles to benefit from influencer incentives</li>
          <li>Start sharing your content with our community</li>
        </ul>
      </div>
    ),

    applicationFormInstructions: (
      <div>
        <p>Please fill in this short form to complete your application.</p>
        <br />
        <p>
          Our Influencer Network is free to join,
           no contracts and your data is not shared without your permission
        </p>
        <br />
        <p>
          All influencer accounts are manually checked
           by our team before gaining access to the platform, we’ll be in touch soon.
        </p>
      </div>
    ),
  },
};

export default BmbTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/bmb.js
 **/